// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1FjEe","content":"styles_content__16qM4","row":"styles_row__1dLup","footer":"styles_footer__26lFO","phraseLength":"styles_phraseLength__1g7CL"};